import { render, staticRenderFns } from "./VodStatusIndicator.vue?vue&type=template&id=19b46f81&scoped=true&"
import script from "./VodStatusIndicator.vue?vue&type=script&lang=js&"
export * from "./VodStatusIndicator.vue?vue&type=script&lang=js&"
import style0 from "./VodStatusIndicator.vue?vue&type=style&index=0&id=19b46f81&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19b46f81",
  null
  
)

export default component.exports